import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'calcQty'
})
export class CalcQtyPipe implements PipeTransform {
  transform(items: any[]): number {
    let total = 0;
    if(items) {
      for (let item of items) {
        total += (+item['qty'] | +item['totalQty']);
      }
    }
    return total;
  }
}


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/shared/pipes/calc-qty.pipe.ts